import { NotificationService } from '../../notification/swal/notification.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Form } from '../../services/form';
import { DependentModel } from '../../models/dependent.model';
import { DuplicateMeepCardService } from '../../services/duplicate-meep-card.service';

@Component({
  selector: 'app-confirm-duplicate',
  templateUrl: './confirm-duplicate.component.html',
  styleUrls: ['./confirm-duplicate.component.less']
})
export class ConfirmDuplicateComponent extends Form {
  routeParams: Params;
  dependent: DependentModel = new DependentModel();

  constructor(private router: Router, private route: ActivatedRoute,
    private notificationService: NotificationService, private duplicateMeepCardService: DuplicateMeepCardService) {
    super();
    this.route.params.subscribe((params: Params) => {
      this.routeParams = params;
    });
  }
  confirmDuplicate() {
    if (this.getFormStatus()) {

        this.duplicateMeepCardService.confirmDuplicate(this.dependent.cardNumber, this.routeParams['meepCardNumber'])
        .then((response: any) => {
          this.notificationService.showSuccessNotification('Segunda via associada com sucesso.')
            .then(() => {
              this.router.navigate([`general/cartoesDependentes`]);
          });
        })
        .catch((err) => {
          this.notificationService.showErrorNotification(err.message);
        });
    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/confirm-duplicate/confirm-duplicate.component.ts